jQuery(function ($){
  $(".image-card__content.news").matchHeight();
  $(".image-card__content.news .image-card__title").matchHeight();
});